__turbopack_context__.v({
  "reviewStar": "ReviewsHeader-module-scss-module__F8qoIa__reviewStar",
  "reviewStarMobile": "ReviewsHeader-module-scss-module__F8qoIa__reviewStarMobile",
  "star": "ReviewsHeader-module-scss-module__F8qoIa__star",
  "textColor": "ReviewsHeader-module-scss-module__F8qoIa__textColor",
});
